import { Button } from '@material-ui/core';
import useRules from 'hooks/useRules';
import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useFreight } from 'useStores/useFreight';

const FreightItems = () => {
  const parentUrl = `/protected/admin/freights`;
  const setTitle = useFreight((state) => state.setTitle);
  const setCategory = useFreight((state) => state.setCategory);
  const location = useLocation();
  const [_, hasRule, __] = useRules();

  React.useEffect(() => {
    setTitle('باربری‌ها');
    setCategory('مدیریت باربری‌ها و سفارشات آنها ...');
  }, [location.pathname]);

  return (
    <div className="d-flex flex-column">
      {hasRule('can_add_new_freight_order') && (
        <Link to={`${parentUrl}/newOrder`}>
          <Button className="justify-content-start fs-6" fullWidth>
            افزودن بار جدید
          </Button>
        </Link>
      )}
      {hasRule('can_list_freights') && (
        <Link to={`/protected/admin/users/freights`}>
          <Button className="justify-content-start fs-6" fullWidth>
            لیست باربری‌ها
          </Button>
        </Link>
      )}
      {hasRule('can_list_freights_orders') && (
        <Link to={`${parentUrl}/freightsOrders`}>
          <Button className="justify-content-start fs-6" fullWidth>
            لیست سفارشات باربری‌ها
          </Button>
        </Link>
      )}
    </div>
  );
};

export default FreightItems;
